import React, { useMemo } from 'react';
import widgetHtmlTemplate from './widget.html?raw';

const Chatbot = () => {
  const srcDoc = useMemo(() => {
    const widgetUrl = import.meta.env.VITE_NOXUS_WIDGET_URL;
    const deploymentId = import.meta.env.VITE_NOXUS_DEPLOYMENT_ID;
    const token = sessionStorage.getItem('accessToken') || '';

    return widgetHtmlTemplate
      .replaceAll('{{ chat_title }}', 'Chat Support')
      .replaceAll('{{ widget_url }}', widgetUrl)
      .replaceAll('{{ deployment_id }}', deploymentId)
      .replaceAll('{{ token }}', token);
  }, []);

  return (
    <iframe
      srcDoc={srcDoc}
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
      }}
      title="PHM Chatbot"
    />
  );
};

export default Chatbot;
